import React from "react";
import CloseIcon from "@material-ui/icons/Close";
import {
  MessageLayout,
  CloseIconFrame,
  InformationFrame,
  InfoMsg,
  ActionItem,
  PopUpTitle,
} from "./styles";
import { useStyles } from "./styles";
import darkTheme from "../../theme/darkTheme";
import theme from "../../theme/index"
import Icons from "../../utils/icons"


const CustomPopup = (props) => {
  const themePalets = props.isDarkMode ? darkTheme : theme;
  const classes = useStyles({isWeb: props.isWeb, themePalets, ...props});
  const handleRightActionClick = () => {
    if(props.rightActionDisabled) {
      return;
    }

    props.rightAction();
  }
  const handleLeftActionClick = () => {
    if(props.leftActionDisabled) {
      return;
    }

    props.leftAction();
  }
  return (
    <div className={classes.customContainer} style={{ width: props.width ?? '100%' }}>
      {props.headerBar === undefined ? props.title && (
        <CloseIconFrame theme={themePalets} isWeb={props.isWeb}>
          <div>
            <PopUpTitle theme={themePalets} isWeb={props.isWeb}>{props.title}</PopUpTitle>
          </div>
          <div>
            {props.dismiss && (
              <CloseIcon
                onClick={props.leftAction}
                className={classes.closeIcon}
              />
            )}
          </div>
        </CloseIconFrame>
      ) : null}

      <MessageLayout isWeb={props.isWeb}>
        <InformationFrame icon={props.icon}>
          {props.icon && <Icons src={props.icon} width={props.iconSize} height={props.iconSize} isDarkMode={props.isDarkMode} iconFill={props.iconFill}/>}
        </InformationFrame>
        {!props.isData ? (
          <InfoMsg theme={themePalets} fontSize={props.fontSize} isWeb={props.isWeb} className={props.infoMessageClass ? classes.infoMessageClass : ""}>
            {props.message}
          </InfoMsg>
        ) : (
          <ul>
            {props.data.length !== 0
              ? props.data.map((item, index) => {
                  return <li>{index}</li>;
                })
              : null}
          </ul>
        )}
      </MessageLayout>
        {((props.leftButtonText || props.rightButtonText) && <ActionItem theme={themePalets} isWeb={props.isWeb}>
          {props.leftButtonText && (
            <div onClick={handleLeftActionClick} className={classes.leftButtonStyle}>
              <span>{props.leftButtonText}</span>
            </div>
          )}
          {props.rightButtonText && (
            <div onClick={handleRightActionClick}  className={classes.rightButtonStyle}>
              <span>{props.rightButtonText}</span>
            </div>
          )}
        </ActionItem>)}
    </div>
  );
};
export default CustomPopup;
